import { LocalStorage } from '../core/storage';
import { FEATURE_FLAGS } from '../core/user/user';

export const isComplianceAlertBackendAggregationEnabled = () => {
  let isComplianceAlertBackendAggregationEnabled = false;

  const featureFlags = LocalStorage.get(FEATURE_FLAGS);
  if (featureFlags) {
    isComplianceAlertBackendAggregationEnabled = featureFlags['compliance_alert_backend_aggregation'];
  }

  return isComplianceAlertBackendAggregationEnabled;
};
